import React from 'react';
import BasicModal from 'Comps/common/BasicModal';
import CheckWithBg from 'Icons/CheckWithBg';
var OrderCreatedModal = function () {
    return (React.createElement(BasicModal, { header: 'Zamówienie zostało złożone' },
        React.createElement("div", { className: "d-flex flex-row align-items-center" },
            React.createElement(CheckWithBg, { className: "text-success mr-2", style: { fontSize: 24 } }),
            React.createElement("div", null, "Za chwil\u0119 zostaniesz przekierowany na stron\u0119 podsumowania zam\u00F3wienia"))));
};
export default OrderCreatedModal;
